import { z } from 'zod';

/**
 * Письмо-приглашение с инструкцией «С чего начать» (БЗ-31): состояние отправки и текст приглашения целиком.
 * Отдельный файл без зависимостей: на него ссылаются схемы приглашений и кабинета владельца портала.
 */
export const INVITE_MAIL_STATUSES = {
  sent: 'Письмо с инструкцией отправлено',
  sending: 'Письмо отправляется',
  failed: 'Письмо не ушло',
  not_configured: 'Почта портала не подключена',
  demo: 'В демо-компании письма не отправляются',
  /** Предел писем-приглашений: на один адрес в час, от компании в сутки */
  limited: 'Письмо не отправлено: предел писем',
} as const;
export type InviteMailStatus = keyof typeof INVITE_MAIL_STATUSES;
export const InviteMailStatus = z.enum(
  Object.keys(INVITE_MAIL_STATUSES) as [InviteMailStatus, ...InviteMailStatus[]],
);

export const InviteMail = z.object({
  status: InviteMailStatus,
  at: z.string().nullable(),
  /** Короткая причина неудачи или предела, без адресов */
  error: z.string().nullable(),
});
export type InviteMail = z.infer<typeof InviteMail>;

/** Текст приглашения с инструкцией для мессенджера: возвращается один раз, как и ссылка */
export const InviteMessage = z.object({
  subject: z.string(),
  text: z.string(),
});
export type InviteMessage = z.infer<typeof InviteMessage>;
